export interface AppRoute {
  id: string
  path: string
  label: string
  title: string
  description: string
  indexable: boolean
  includeInNavigation: boolean
  includeInSitemap: boolean
}

export const appRoutes = [
  {
    id: 'home',
    path: '/',
    label: 'Inicio',
    title: 'Elecciones Seccionales 2027 en Ecuador | El Telégrafo',
    description: 'Candidatos, propuestas, cómo votar y resultados de las Elecciones Seccionales y CPCCS 2027 en Ecuador.',
    indexable: true,
    includeInNavigation: true,
    includeInSitemap: true,
  },
  {
    id: 'candidatos',
    path: '/candidatos',
    label: 'Candidatos',
    title: 'Candidatos a las Elecciones Seccionales 2027 | El Telégrafo',
    description: 'Conoce los perfiles, propuestas y noticias de los candidatos a las Elecciones Seccionales 2027 en Ecuador.',
    indexable: true,
    includeInNavigation: true,
    includeInSitemap: true,
  },
  {
    id: 'resultados',
    path: '/resultados',
    label: 'Resultados',
    title: 'Resultados de las Elecciones Seccionales 2027 | El Telégrafo',
    description: 'Consulta el conteo y las actualizaciones de resultados de las Elecciones Seccionales y CPCCS 2027.',
    indexable: true,
    includeInNavigation: true,
    includeInSitemap: true,
  },
  {
    id: 'reporteria-ciudadana',
    path: '/reporteria-ciudadana',
    label: 'Reportería ciudadana',
    title: 'Reportería ciudadana de las Elecciones 2027 | El Telégrafo',
    description: 'Videos y reportes ciudadanos sobre las Elecciones Seccionales 2027 desde barrios y comunidades de Ecuador.',
    indexable: true,
    includeInNavigation: true,
    includeInSitemap: true,
  },
  {
    id: 'reporteria-videos',
    path: '/reporteria-ciudadana/videos',
    label: 'Videos de reportería',
    title: 'Videos de las Elecciones Seccionales 2027 | El Telégrafo',
    description: 'Reportes ciudadanos y cobertura en video de las Elecciones Seccionales 2027 de El Telégrafo.',
    indexable: true,
    includeInNavigation: false,
    includeInSitemap: true,
  },
] satisfies AppRoute[]

export const navigationRoutes = appRoutes.filter((route) => route.includeInNavigation)

function routesById(routeIds: string[]) {
  const routes = appRoutes as readonly AppRoute[]

  return routeIds
    .map((id) => routes.find((route) => route.id === id))
    .filter((route): route is AppRoute => Boolean(route?.includeInNavigation))
}

export const desktopHeaderRoutes = routesById([
  'home',
  'resultados',
  'candidatos',
  'reporteria-ciudadana',
])

export const mobileMenuRoutes = routesById([
  'home',
  'candidatos',
  'resultados',
])

export const mobileFooterPrimaryRoutes = routesById([
  'home',
  'candidatos',
  'resultados',
])

export const mobileFooterSecondaryRoutes = routesById([
  'reporteria-ciudadana',
])

export function findRouteByPath(path: string) {
  return appRoutes.find((route) => route.path === path)
}
